import React from 'react';
import { Link } from 'react-router-dom';

const containerStyle = {
  maxWidth: '900px',
  margin: '0 auto',
  padding: '80px 20px 40px 20px',
  color: '#1d1d1f',
  lineHeight: '1.6',
};

const titleStyle = {
  fontSize: '2.5rem',
  fontWeight: '600',
  marginBottom: '2rem',
  color: '#1d1d1f',
};

const sectionStyle = {
  marginBottom: '2rem',
};

const headingStyle = {
  fontSize: '1.5rem',
  fontWeight: '600',
  marginTop: '2rem',
  marginBottom: '1rem',
  color: '#1d1d1f',
};

const paragraphStyle = {
  marginBottom: '1rem',
  fontSize: '15px',
  color: '#86868b',
};

const linkStyle = {
  color: '#0071e3',
  textDecoration: 'none',
};

const lastUpdatedStyle = {
  fontSize: '13px',
  color: '#86868b',
  fontStyle: 'italic',
  marginBottom: '2rem',
};

export default function TermsOfService() {
  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Terms of Service</h1>
      <p style={lastUpdatedStyle}>Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>1. Acceptance of Terms</h2>
        <p style={paragraphStyle}>
          By accessing and using MyPictor ("the Service"), you accept and agree to be bound by the terms and 
          provision of this agreement. If you do not agree to abide by the above, please do not use this service.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>2. Description of Service</h2>
        <p style={paragraphStyle}>
          MyPictor is a desktop application that provides photo cataloging, organization, and management services. 
          The Service allows users to organize, search, and manage their photo collections using various features 
          including AI-powered organization and metadata extraction.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>3. User Accounts</h2>
        <p style={paragraphStyle}>
          <strong>3.1 Account Creation:</strong> To use certain features of the Service, you may be required to 
          create an account. You agree to provide accurate, current, and complete information during registration 
          and to update such information to keep it accurate, current, and complete.
        </p>
        <p style={paragraphStyle}>
          <strong>3.2 Account Security:</strong> You are responsible for maintaining the confidentiality of your 
          account credentials and for all activities that occur under your account. You agree to notify us immediately 
          of any unauthorized use of your account.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>4. Acceptable Use</h2>
        <p style={paragraphStyle}>
          You agree not to use the Service to:
        </p>
        <ul style={{ ...paragraphStyle, paddingLeft: '20px' }}>
          <li>Violate any applicable laws or regulations</li>
          <li>Infringe upon the rights of others</li>
          <li>Upload or transmit any malicious code, viruses, or harmful data</li>
          <li>Attempt to gain unauthorized access to the Service or related systems</li>
          <li>Interfere with or disrupt the Service or servers</li>
          <li>Use the Service for any illegal or unauthorized purpose</li>
          <li>Upload content that violates intellectual property rights</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>5. Intellectual Property Rights</h2>
        <p style={paragraphStyle}>
          <strong>5.1 Our Rights:</strong> The Service and its original content, features, and functionality are 
          owned by MyPictor and are protected by international copyright, trademark, patent, trade secret, and other 
          intellectual property laws.
        </p>
        <p style={paragraphStyle}>
          <strong>5.2 Your Content:</strong> You retain all rights to your photos and content. By using the Service, 
          you grant us a limited, non-exclusive license to process and organize your content solely for the purpose of 
          providing the Service to you.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>6. Privacy</h2>
        <p style={paragraphStyle}>
          Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy, which 
          also governs your use of the Service, to understand our practices. By using the Service, you consent to 
          the collection and use of information in accordance with our Privacy Policy.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>7. Service Availability</h2>
        <p style={paragraphStyle}>
          We strive to provide reliable service, but we do not guarantee that the Service will be available at all 
          times or that it will be error-free. We reserve the right to modify, suspend, or discontinue the Service 
          (or any part thereof) at any time with or without notice.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>8. Disclaimer of Warranties</h2>
        <p style={paragraphStyle}>
          THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, 
          INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR 
          NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>9. Limitation of Liability</h2>
        <p style={paragraphStyle}>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL MYPICTOR, ITS AFFILIATES, OR THEIR RESPECTIVE 
          OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, 
          OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY 
          LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>10. Indemnification</h2>
        <p style={paragraphStyle}>
          You agree to defend, indemnify, and hold harmless MyPictor and its affiliates from and against any claims, 
          liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any 
          way connected with your use of the Service or violation of these Terms.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>11. Termination</h2>
        <p style={paragraphStyle}>
          We may terminate or suspend your account and access to the Service immediately, without prior notice or 
          liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, 
          your right to use the Service will immediately cease.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>12. Governing Law</h2>
        <p style={paragraphStyle}>
          These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which 
          MyPictor operates, without regard to its conflict of law provisions.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>13. Changes to Terms</h2>
        <p style={paragraphStyle}>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is 
          material, we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a 
          material change will be determined at our sole discretion.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>14. Contact Information</h2>
        <p style={paragraphStyle}>
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p style={paragraphStyle}>
          Email: legal@mypictor.com<br />
          Website: <Link to="/" style={linkStyle}>www.mypictor.com</Link>
        </p>
      </section>
    </div>
  );
}

